import { Link } from "react-router-dom";

interface MenuLinkProps {
  href: string;
  children: React.ReactNode;
}

export function MenuLink({ href, children }: MenuLinkProps) {
  const isInternalLink = href.startsWith("/");
  
  if (isInternalLink) {
    return (
      <Link 
        to={href} 
        className="block px-4 py-3 text-sm text-foreground hover:bg-accent cursor-pointer transition-colors focus:outline-none focus-visible:outline-none"
      >
        {children}
      </Link>
    );
  }
  
  return (
    <a 
      href={href} 
      className="block px-4 py-3 text-sm text-foreground hover:bg-accent cursor-pointer transition-colors focus:outline-none focus-visible:outline-none"
    >
      {children}
    </a>
  );
}